<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="អតិថិជនទាំងអស់" name="first"></el-tab-pane>
			<el-tab-pane label="បង្កើតអតិថិជនថ្មី" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ លេខកូដ ឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកាត</label>
						<md-input v-model="search.text" type="text"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-30">
					<md-field>
						<label>សាខា *</label>
						<md-select placeholder="សាខា *" v-model="search.branch">
							<md-option value="">សាខា (ទាំងអស់)</md-option>
							<md-option v-for="branch in branchList" :value="branch.id">{{branch.name}}</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-size-20">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក
					</md-button>
				</div>
			</div>

			<md-table v-if="clientList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>លេខកូដ</md-table-head>
					<md-table-head>អតិថិជន</md-table-head>
					<md-table-head>លេខកាត</md-table-head>
					<md-table-head>សុពលភាព</md-table-head>
					<md-table-head>សាខា</md-table-head>
					<md-table-head>ថ្ងៃបង្កើត</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(client, index) in clientList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<!-- <img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px"> -->
						<b>{{ client.code }}</b>
					</md-table-cell>
					<md-table-cell><b>{{ client.name }}<br>{{ client.phone }}</b></md-table-cell>
					<md-table-cell><b v-if="String(client.card).length >0">{{ client.card }}</b><b v-else>មិនមាន</b></md-table-cell>
					<md-table-cell>
						<b><template v-if="config.timelify(client.expiry_date) != 'មិនមានសុពលភាព'">
							<span class="green">{{config.expirydate(client.expiry_date)}}</span>
							({{config.timelify(client.expiry_date)}})
						</template>
							<span class="late" v-if="config.timelify(client.expiry_date) == 'មិនមានសុពលភាព'">មិនមានសុពលភាព</span></b>
					</md-table-cell>
					<md-table-cell><b>{{client.branch_name}}</b></md-table-cell>
					<md-table-cell><b>{{ config.datelify(client.created_date) }}</b></md-table-cell>
					<md-table-cell>
						<router-link :to="'/clients/detail/' + client.hash">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
							</md-button>
						</router-link>
						<router-link :to="'/clients/renew/' + client.hash">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>published_with_changes</md-icon>
								<md-tooltip md-direction="top">បន្តសុពលភាពអតិថិជន</md-tooltip>
							</md-button>
						</router-link>
						<router-link :to="'/clients/edit/' + client.hash">
							<md-button class="md-just-icon md-simple md-info">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែប្រែព័ត៌មាន</md-tooltip>
							</md-button>
						</router-link>
						<!-- <md-button class="md-just-icon md-simple md-info">
							<md-icon>edit</md-icon>
							<md-tooltip md-direction="top">Edit client information</md-tooltip>
						</md-button>
						-->
						<md-button class="md-just-icon md-simple md-danger" @click="onDelete(client.hash)">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">លុបអតិថិជននេះ</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="clientList.length == 0 && loadMore == true">មិនមានអតិថិជន</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>



		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានអតិថិជន</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវឱ្យបំពេញ</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ឈ្មោះអតិថិជន *</label>
								<md-input type="text" v-model="client.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>លេខទូរស័ព្ទអតិថិជន *</label>
								<md-input type="text" v-model="client.phone"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>លេខកូដកាត *</label>
								<md-input type="text" v-model="client.card"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>កំណត់ចំណាំ</label>
								<md-input type="text" v-model="client.note"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<label>សាខា *</label>
							<v-select label="name" inputId="id" :clearable="false" :options="branchList"
								v-model="client.branchArray">
							</v-select>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<label>កញ្ចប់សេវាកម្ម *</label>
							<v-select label="name" inputId="id" :clearable="false" :options="packageList"
								v-model="client.packageArray">
							</v-select>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះអតិថិជន</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.name).length > 0">{{client.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>លេខទូរស័ព្ទអតិថិជន</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.phone).length > 0">{{client.phone}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>លេខកាត</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.card).length > 0">{{client.card}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>សាខា</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.branch_id).length > 0">{{client.branchArray.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>កញ្ចប់សេវាកម្ម</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.package_id).length > 0">{{client.packageArray.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>កំណត់ចំណាំ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.note).length > 0">{{client.note}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="postClient()">បង្កើត</md-button>
				</div>
			</div>

		</div>
		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបអតិថិជននេះពិតមែនទេ ?"
				md-content="អតិថិជននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
				@md-cancel="onCancel" @md-confirm="onDelete" />
		</div>
	</div>



</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
			this.getBranch();
			this.getPackage();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: "",
					branch: ""
				},
				client: {
					name: "",
					phone: "",
					card: "",
					note: "",
					branch_id: "",
					package_id: "",
					packageArray: "",
					branchArray: ""
				},
				loadMore: true,
				clientList: [],
				branchList: [],
				packageList: [],

			}
		},
		watch: {
			'client.branchArray': function (val) {
				if (String(this.client.branchArray).length > 5) {
					this.client.branch_id = this.client.branchArray.id;
				} else {
					this.client.branch_id = "";
				}
			},
			'client.packageArray': function (val) {
				if (String(this.client.packageArray).length > 5) {
					this.client.package_id = this.client.packageArray.id;
				} else {
					this.client.package_id = "";
				}
			}
		},
		methods: {
			postClient() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/client/post", {
					client: this.client
				}).then(data => {
					if (data.body.status == 'success') {
						this.searchHandler();
						this.tabName = 'first'
						this.$notification.notify({
							message: "អតិថិជនត្រូវបានបង្កើតដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.clearAll();
					}

				})
			},
			getBranch() {
				this.$http.post(this.config.api + "/admin/branch/search", {
					text: "",
					offset: 0
				}).then(data => {
					this.branchList = data.body.data;
				})
			},
			getPackage() {
				this.$http.post(this.config.api + "/admin/package/search", {
					text: "",
					offset: 0
				}).then(data => {
					this.packageList = data.body.data;
				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.search.text,
					branch: this.search.branch,
					offset: more ? this.clientList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.clientList = more ? this.clientList.concat(data.body.data) : data.body.data;
					// this.clientList = data.body.data;
				})
			},
			checkValidation() {
				if (String(this.client.name).length > 0 && String(this.client.phone).length > 0 && String(this.client.branch_id).length > 0 && String(this.client.package_id).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបញ្ចូលព័ត៌មាន។",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			onDelete(hash = "") {
				if(String(hash).length > 0 && this.deleteSelected == "") {
					this.deleteSelected = hash;
					this.deleteDialogActive = true;
					return;
				} else {
					this.$http.post(this.config.api + "/admin/client/delete", {
						hash: this.deleteSelected
					}).then(data => {
						if (data.body.status == 'success') {
							this.searchHandler();
							this.tabName = 'first'
							this.$notification.notify({
								message: "អតិថិជនត្រូវបានលុបដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							});
							this.clearAll();
						}

					})
				}


			},
			onCancel() {
				this.deleteSelected = "";
				this.deleteDialogActive = false;
			},
			clearAll() {
				this.search.text = "";
				this.deleteDialogActive = false;
				this.deleteSelected = "";
				this.client = {
					name: "",
					phone: "",
					card: "",
					note: "",
					branch_id: "",
					package_id: "",
					packageArray: "",
					branchArray: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/View.vue